import utils from "../utils";

export default function errorHandler(errorCode: number) {
  switch (errorCode) {
    case 5010:
      return utils.toast({ type: "ERROR", text: "خطای پارامتر", id: "5010" });
    case 5011:
      return utils.toast({
        type: "ERROR",
        text: "تعداد درخواست ها زیاد است",
        id: "5011",
      });
    case 5015:
      return utils.toast({
        type: "ERROR",
        text: "کد ارسال شده است",
        id: "5015",
      });
    case 5020:
      return utils.toast({
        type: "ERROR",
        text: "خطا: نام کاربری وجود دارد",
        id: "5020",
      });
    case 5021:
      return utils.toast({
        type: "ERROR",
        text: "نام کاربری پیدا نشد",
        id: "5021",
      });
    case 5022:
      return utils.toast({ type: "ERROR", text: "کاربر پیدا نشد", id: "5022" });
    case 5023:
      return utils.toast({
        type: "ERROR",
        text: "استفاده از دسته خطا در زیر دسته",
        id: "5023",
      });
    case 5024:
      return utils.toast({
        type: "ERROR",
        text: "کد فایل خطا تکراری است",
        id: "5024",
      });
    case 5029:
      return utils.toast({
        type: "ERROR",
        text: "این شماره قبلا در سیستم ثبت شده است",
        id: "5029",
      });
    case 5042:
      return utils.toast({
        type: "ERROR",
        text: "شماره موبایل تکراری است",
        id: "5042",
      });
    case 5097:
      return utils.toast({
        type: "ERROR",
        text: "دسترسی داده نشده است",
        id: "5097",
      });
    // case 5098:
    //   return utils.toast({
    //     type: "ERROR",
    //     text: "احراز هویت ناموفق بود",
    //     id: "5098",
    //   });
    case 5099:
      return utils.toast({ type: "ERROR", text: "خطای داخلی", id: "5099" });
    // !! ========================================================================================================
    // !!                                             Custom Error Codes
    // !! ========================================================================================================
    case 7001:
      return utils.toast({
        type: "ERROR",
        text: "کدملی تکراری است",
        id: "5099",
      });
    case 7005:
      return utils.toast({
        type: "ERROR",
        text: "مدرسه تایید نشده",
        id: "7005",
      });
    case 7006:
      return utils.toast({
        type: "ERROR",
        text: "مدرسه وجود ندارد",
        id: "7005",
      });
    case 7007:
      return utils.toast({
        type: "ERROR",
        text: "اطلاعات مدرسه کامل نیست",
        id: "7007",
      });

    case 9001:
      return utils.toast({
        type: "ERROR",
        text: "فیلد های اجباری را پرکنید",
        id: "9001",
      });
    case 9002:
      return utils.toast({
        type: "ERROR",
        text: "رمزهای وارد شده یکسان نیستند",
        id: "9002",
      });
    case 9003:
      return utils.toast({
        type: "ERROR",
        text: "شماره‌ی موبایل نادرست است",
        id: "9003",
      });
    case 9004:
      return utils.toast({
        type: "ERROR",
        text: "حداقل هشت کاراکتر، حداقل یک حرف بزرگ، یک حرف کوچک و یک عدد و یک حرف شامل [!@#$%^&*] برای فیلد رمز اجباری می‌باشد",
        id: "9004",
      });
    case 9005:
      return utils.toast({
        type: "ERROR",
        text: "فقط عدد مجاز می‌باشد",
        id: "9005",
      });
    case 9006:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک دسته بندی انتخاب کنید",
        id: "9006",
      });

    case 9007:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک مورد را انتخاب کنید",
        id: "9007",
      });
    case 9008:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک دسته بندی انتخاب کنید",
        id: "9008",
      });
    case 9009:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک زیر دسته بندی انتخاب کنید",
        id: "9009",
      });
    case 9010:
      return utils.toast({
        type: "ERROR",
        text: "لطفا نوع ملک را مشخص کنید",
        id: "9010",
      });
    case 9011:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک استان انتخاب کنید",
        id: "9011",
      });
    case 9012:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک شهر انتخاب کنید",
        id: "9012",
      });
    case 9013:
      return utils.toast({
        type: "ERROR",
        text: "لطفا یک آموزش و پرورش انتخاب کنید",
        id: "9013",
      });

    // !! ========================================================================================================
    // !!                                             financial
    // !! ========================================================================================================

    case 6025:
      return utils.toast({
        type: "ERROR",
        text: "گروه مالی قبلا استفاده شده است",
        id: "6025",
      });
    case 6026:
      return utils.toast({
        type: "ERROR",
        text: "تراکنش یافت نشد",
        id: "6026",
      });
    case 6028:
      return utils.toast({
        type: "ERROR",
        text: "درگاه پرداخت در دسترس نیست",
        id: "6028",
      });
    case 6030:
      return utils.toast({
        type: "ERROR",
        text: "موجودی کافی نیست",
        id: "6030",
      });
    case 6031:
      return utils.toast({
        type: "ERROR",
        text: "راننده بدهی ندارد",
        id: "6031",
      });
    case 6032:
      return utils.toast({
        type: "ERROR",
        text: "فاکتور تایید نشده",
        id: "6032",
      });
    case 6033:
      return utils.toast({
        type: "ERROR",
        text: "فاکتوری انتخاب نشده است",
        id: "6033",
      });
    case 6037:
      return utils.toast({
        type: "ERROR",
        text: "تراکنش ناموفق بود",
        id: "6037",
      });
    case 6038:
      return utils.toast({
        type: "ERROR",
        text: "مقدار وارد شده از بدهی کمتر است",
        id: "6038",
      });
    case 6039:
      return utils.toast({
        type: "ERROR",
        text: "درگاه بانک صادرات در دسترس نیست",
        id: "6039",
      });
    case 6040:
      return utils.toast({
        type: "ERROR",
        text: "موجودی کافی نیست",
        id: "6040",
      });
    case 6046:
      return utils.toast({
        type: "ERROR",
        text: "حداقل مبلغ قابل برداشت 100 هزار تومان است",
        id: "6046",
      });
    case 6047:
      return utils.toast({
        type: "ERROR",
        text: "حداکثر مبلغ قابل برداشت 5 میلیون تومان است",
        id: "6047",
      });
    case 6048:
      return utils.toast({
        type: "ERROR",
        text: "فاکتور وجود ندارد",
        id: "6048",
      });
    case 8002:
      return utils.toast({
        type: "ERROR",
        text: "متن پاسخ خالی است",
        id: "8002",
      });
    case 8003:
      return utils.toast({
        type: "ERROR",
        text: "متن پاسخ کمتر از 10 حرف است",
        id: "8002",
      });

    // !! ========================================================================================================
    // !!                                             front end errors  3500
    // !! ========================================================================================================
    case 3500:
      return utils.toast({
        type: "ERROR",
        text: "تاریخ شروع سرویس خالی است",
        id: "3500",
      });
    case 3501:
      return utils.toast({
        type: "ERROR",
        text: "قیمت سرویس وارد نشده است",
        id: "3501",
      });

    // default:
    //   console.error({ errorCode });
    //   utils.toast({ type: `ERROR`, text: "خطایی پیش آمده", id: "9999" });
    //   break;
  }
}

// const ERROR_TRACKING_CODE_DUPLICATE = 6041;
// const ERROR_BANK_iNFORMATION_NOT_FOUND = 6042;
// const ERROR_WITHDRAWAL_ID_NOT_FOUND = 6043;
// const ERROR_WITHDRAWAL_STATUS_NOT_PENDING = 6044;
// const ERROR_ZARINPAL_TOKEN = 6045;
// const ERROR_FACTOR_NOT_FOUND = 6048;
// const OLD_TRANSACTION = 6036;
// const ERROR_INVOICE_STATUS_NOT_MATCH = 6035;
// const ERROR_REASEN_NOT_MATCH = 6034;
//const ERROR_IN_CALL_BACK_TRANSACTION_PARAM = 6027;

// const VERIFY_CODE_SENT = 2210
// const USER_CREATED = 2211
// const USER_UPDATED = 2212
// const RESPONSE_SUCCESSFUL = 2213
// const PAYMENTS_WERE_MADE = 2214
// const INVOICE_CREATED = 2215
// const INVOICE_UPDATED = 2216
// const RESPONSE_DELETE = 2240

// const ERROR_PARAM = 5010

// const ERROR_NOT_A_NUMBER = 6011;
// const ERROR_INVALID_PHONE_NUMBER = 6012;
// const ERROR_SMS_NOT_SEND = 6013;
// const ERROR_INVALID_VERIFY_NUMBER = 6014;
// const ERROR_TOO_MANY_ATTEMPT = 6015;
// const ERROR_TYPE_NOT_MACH = 6016;
// const ERROR_TOKEN = 6017;
// const ERROR_GENDER = 6018;
// const ERROR_FULL_NAME_MUST_STRING = 6019;
// const ERROR_WRONG_PARAMETER = 6020;
// const ERROR_WRONG_PAYMENT_REASON = 6021;
// const ERROR_DUPLICATE = 6022;
// const ERROR_NOT_FOUND = 6023;
// const ERROR_FORBIDDEN = 6024;

// const ERROR_REDIS = 5097
// const AUTH_FAILED = 5098
// const ERROR_INTERNAL = 5099
// const duplicate phoneNumber = 5042
